import React from "react";
import { Flame } from "lucide-react";

const STYLE = {
  7: "bg-sky-100 text-[#0090cc] border border-sky-200",
  30: "bg-[#00b4ff] text-white border border-[#00b4ff]",
  100: "bg-gradient-to-r from-amber-300 to-amber-500 text-white border border-amber-400",
};

export default function MilestoneBadge({ milestone, testId, className = "" }) {
  if (!milestone) return null;
  return (
    <span data-testid={testId} title={`${milestone}-day Daily Quiz streak`}
          className={`inline-flex items-center gap-0.5 px-1.5 py-0.5 rounded font-mono-plex font-bold tracking-wider text-[8px] leading-none whitespace-nowrap align-middle ${STYLE[milestone]} ${className}`}>
      <Flame size={9} className="fill-current" /> {milestone}-DAY
    </span>
  );
}
